// The single implementation (2026-07-27 duplicate-name collision fix — see
// NotificationPanel dedup in shared/components/Notifications.js for the
// matching component-level move). There used to be one copy of these two
// functions, in workspace/functions/notifications/markNotificationRead.js,
// el.call'd only by the canonical NotificationPanel that lived in
// workspace/components/NotificationBell.js.
//
// It lives in SHARED rather than workspace because shared is the layer every
// app scope merges. Canvas's standalone bundle links shared (never workspace,
// see canvas/sharedLibraries.js) and mounts NotificationPanel through
// AppHeader's NotificationWrapper — keeping the only copy in workspace would
// have left `el.call('markNotificationRead', …)` / `el.call('markAllNotificationsRead')`
// unresolved there once NotificationPanel moved to shared too.
//
// migrated 2026-04-27 to SDK route workspaceProject.notifications (update / markAllRead)
import { getSDK } from './sdk.js'

export const markNotificationRead = async function (notifId) {
  if (!notifId) return
  const root = this?.state?.root
  if (!root) return
  // Optimistic update
  root.update({
    notifs: (root.notifs || []).map((n) => (n.id === notifId ? { ...n, read: true } : n))
  })
  try {
    await getSDK().execute('workspaceProject.notifications', 'update', { id: notifId })
  } catch (e) {
    console.error('[markNotificationRead]', e?.message || e)
  }
}

export const markAllNotificationsRead = async function () {
  const root = this?.state?.root
  if (!root) return
  const me = root.currentUserEmail
  if (!me) return
  // Optimistic update
  root.update({
    notifs: (root.notifs || []).map((n) => ({ ...n, read: true }))
  })
  try {
    await getSDK().execute('workspaceProject.notifications', 'markAllRead', {})
  } catch (e) {
    console.error('[markAllNotificationsRead]', e?.message || e)
  }
}
